import { VALIDATE,LOADING,REGISTER,CLEAN,ERR_REGISTER,ERR_VALIDATE, ADD_ADVISERS} from "./actions";

const initialState = {
 permit:false,
 error_permit : false,
 error_register:false,
 register:false,
 loading :false,
 callApi: true,
 listAdvisers: [],
};

const adviserReducer = (state = initialState, action) => {
  const { type, register, permit ,loading,error_permit,error_register, listAdvisers} = action;
  
  switch (type) {
    case VALIDATE:
      return { ...state, permit,error_permit:false,callApi:false};
    case ERR_VALIDATE:
        return { ...state, error_permit};   
    case REGISTER:
      return { ...state, register,error_register:false,error_permit:false,callApi:false}; 
    case ERR_REGISTER:
      return { ...state, error_register};      
    case ADD_ADVISERS:
      return { ...state, listAdvisers};   
    case LOADING:
      return { ...state, loading} 
    case CLEAN:
        return {
            permit:false,
            error_permit : false,
            error_register:false,
            register:false,
            loading :false
           };           
    default:
      return state;
  }
};

export default adviserReducer;
